<script lang="ts" setup>
import { CONTENT_QUERY_LIST } from '~/constants'
import type { Content, ContentType } from '~/types'
import { useConfigStore } from '~/store'

const route = useRoute()
const channelType = route.params.channel_type as ContentType

const config = useConfigStore()

config.setState({
  leaderboardPID: 'leaderboard_categories',
  contentType: channelType,
  contentId: undefined,
  showAds: config.showAds,
})

const channelName = computed(() => CONTENT_QUERY_LIST.find(({ type }) => type === channelType)?.label || channelType)

useHead({ title: channelName.value })

const items = reactive<Content[]>([])
const totalNumber = ref(0)

const listContentByPage = listContentByPageWrapper(channelType)

async function fetch(page: number) {
  const { results, total } = await listContentByPage(page)
  totalNumber.value = total
  items.push(...results)
}

const tailEl = ref<HTMLDivElement>()

let page = 0
const isLoading = ref(false)

async function loadingNext() {
  if (isLoading.value)
    return
  isLoading.value = true
  try {
    page += 1
    await fetch(page)
  }
  finally {
    isLoading.value = false
  }
}

if (process.server)
  await loadingNext()
else
  loadingNext()

if (process.client) {
  useIntervalFn(() => {
    if (!tailEl.value || isLoading.value || items.length === totalNumber.value)
      return

    const { top } = tailEl.value.getBoundingClientRect()
    const delta = top - window.innerHeight
    if (delta < 400)
      loadingNext()
  }, 500)
}
</script>

<template>
  <div class="pt-4">
    <h1 class="text-3xl text-center">
      {{ channelName }}
    </h1>
    <div
      class="grid gap-4 p-8 grid-cols-[repeat(auto-fill,minmax(10rem,1fr))] lg:grid-cols-[repeat(auto-fill,minmax(300px,1fr))]"
    >
      <template v-for="(item, index) in items" :key="item.id">
        <ContentPlacement v-if="config.showAds && index === 4" placement-id="mrec_categories" />
        <ContentCard v-else :item="item">
          <template #title>
            {{ item.title }}
          </template>
        </ContentCard>
      </template>
    </div>
    <div ref="tailEl" />
    <ClientOnly>
      <Icon v-if="isLoading" name="i-svg-spinners-3-dots-fade" size="2rem" class="w-full m-auto" />
    </ClientOnly>
  </div>
</template>

<style scoped></style>
